/*
 * Cart update bridge.
 *
 * The FoxKit in-cart upsell ("Customers also bought") only re-renders when it
 * hears the theme's `cart-update` event. The theme emits that itself from
 * cart.js whenever ITS OWN buy button adds to the cart. GemPages product pages
 * run their own add-to-cart, so nothing ever emits the event there and the
 * upsell stays empty — which is why the section is missing on the shoes (they
 * are on GemPages templates) but present on sheets and mats (theme templates).
 *
 * This watches for a successful write to the cart made by anyone — fetch or
 * XHR, GemPages or any other app — and emits the theme's own event so every
 * listener refreshes. Nothing app-specific: it only re-publishes a signal the
 * theme already defines.
 *
 * It deliberately stays quiet when the theme has just announced the same
 * change, so listeners are not told twice for one add.
 */
(function () {
  if (window.__cartUpdateBridge) return;
  window.__cartUpdateBridge = true;

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/i;
  var QUIET_MS = 600; // how recently the theme must have spoken for us to stay quiet
  var DEBOUNCE_MS = 250;

  var lastThemeEmit = 0;
  var selfEmitting = false;
  var pending = null;

  function bus() {
    return window.MinimogEvents;
  }

  function eventName() {
    return (
      (window.MinimogTheme &&
        window.MinimogTheme.pubSubEvents &&
        window.MinimogTheme.pubSubEvents.cartUpdate) ||
      'cart-update'
    );
  }

  // Listen to the theme's own announcements so we can tell whether one just happened.
  function watchTheme() {
    var b = bus();
    if (!b || typeof b.subscribe !== 'function') return false;
    b.subscribe(eventName(), function () {
      if (!selfEmitting) lastThemeEmit = Date.now();
    });
    return true;
  }

  /*
   * The `source` on the payload is not cosmetic. FoxKit's in-cart upsell
   * subscribes as:
   *     window.subscribe('cart-update', t => { 'product-form' === t?.source && this.getCart() })
   * so it ignores any announcement that is not labelled as coming from a
   * product form. An add IS a product-form add as far as every listener is
   * concerned, whoever ran the request; other cart writes are labelled the way
   * cart.js labels its own.
   */
  function sourceFor(url) {
    return /\/cart\/add/i.test(url) ? 'product-form' : 'main-cart-items';
  }

  function announce(source) {
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (Date.now() - lastThemeEmit < QUIET_MS) return;
      var b = bus();
      if (!b || typeof b.emit !== 'function') return;

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r && r.ok ? r.json() : null;
        })
        .then(function (cart) {
          if (!cart) return;
          // The theme may have announced while we were fetching.
          if (Date.now() - lastThemeEmit < QUIET_MS) return;
          cart.source = source || 'product-form';
          selfEmitting = true;
          try {
            b.emit(eventName(), cart);
          } finally {
            selfEmitting = false;
          }
        })
        .catch(function () {});
    }, DEBOUNCE_MS);
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var result = originalFetch.apply(this, arguments);
      if (method === 'POST' && CART_WRITE.test(url)) {
        // A separate branch: the caller still gets the original promise untouched.
        result
          .then(function (res) {
            if (res && res.ok) announce(sourceFor(url));
          })
          .catch(function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      this.__cartWrite = String(method).toUpperCase() === 'POST' && CART_WRITE.test(String(url));
      this.__cartSource = sourceFor(String(url));
    } catch (e) {
      this.__cartWrite = false;
    }
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__cartWrite) {
      var source = this.__cartSource;
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) announce(source);
      });
    }
    return originalSend.apply(this, arguments);
  };

  // The event bus is created by the theme's vendor bundle, which may not have
  // run yet when this file executes.
  if (!watchTheme()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (watchTheme() || ++tries > 40) clearInterval(poll);
    }, 250);
  }
})();
